import type { ScriptStatus } from './types'

const WEB_SNIPPET_TEMPLATE =
  '<script async src="https://cdn.newtail.com.br/retail-media/scripts/vtexrma-agent.1.0.0.js"></script>'

export const WEB_DOCS_URL =
  'https://developers.vtex.com/docs/guides/installing-the-offsite-capture-web-script'

export const MOBILE_SDK_DOCS_URL =
  'https://developers.vtex.com/docs/guides/installing-activity-flow-in-mobile-apps'

export const buildWebSnippet = () => WEB_SNIPPET_TEMPLATE

export const statusTagTone = (
  status: ScriptStatus | undefined
): 'green' | 'gray' => (status?.active ? 'green' : 'gray')
